import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';
import { AppMessageService } from '../app-message/app-message.service';
import { AppMessage } from '../app-message/app-message';

/**
 * This service can register and monitor status checks for external APIs or other datasources and raise alarms when
 * they become unavailable.
 */
@Injectable()
export class StatusListenerService {

  /**
   * status listener Subject
   * @type {Subject<any>}
   */
  private statusData = new Subject<any>();
  /**
   * Observable for status listener Subject
   * @type {Observable<any>}
   */
  public statusChanged$ = this.statusData.asObservable();
  /**
   * ES 6 Map for current status listeners
   * @type {Map<string, any>}
   */
  private statusListeners = new Map<string, any>();

  constructor(private appMessageService: AppMessageService) {

  }

  /**
   * Add new status listener
   * @param {number} timeout - wait for desired time before API is marked as unavailable, ms
   * @param {string} api - name of external API, for example 'KoneGIS'
   */
  public setStatusListener(timeout: number, api: string) {
    this.statusListeners.set(api, setTimeout(() => {
      console.log('STATUS TIMEOUT TRIGGERED!');
      this.statusData.next({key: api, msg: 'Error with ' + api});
      this.appMessageService.broadcastAlarm(new AppMessage(true, 'Connection to ' + api + ' lost. Data accuracy may be reduced.', 'warning', 'api', api));
    }, timeout));
  }

  /**
   * Remove status listener from listener pool.
   * @param {string} api - name of external API, for example 'KoneGIS'
   */
  public clearStatusListener(api: string) {
    if (this.statusListeners.has(api)) {
      clearTimeout(this.statusListeners.get(api));
    }
    this.statusData.next({key: api, msg: false});
    this.appMessageService.broadcastAlarm(new AppMessage(false, '', 'info', 'api', api));
  }
}
